import { Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import * as moment from 'moment';
import { Observable} from 'rxjs';
import { map, startWith} from 'rxjs/operators';
import { ReunionesService} from '../_services/reuniones.service';
import { MY_FORMATS} from '../../../_models/moment-formats';

const MOCK = [
  {id: 1, nombre: 'Tipo 1'},
  {id: 2, nombre: 'Tipo 2'},
  {id: 3, nombre: 'Tipo 3'},
  {id: 4, nombre: 'Tipo 4'},
  {id: 5, nombre: 'Tipo 5'},
  {id: 6, nombre: 'Tipo 6'},
];

@Component({
  selector: 'reuniones-busqueda',
  standalone: false,
  templateUrl: 'reuniones-busqueda.component.html',
  styleUrls: ['reuniones-busqueda.component.scss'],
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})

export class ReunionesBusquedaComponent implements OnInit {

  searchForm = new UntypedFormGroup({
    searchTerm: new UntypedFormControl(''),
    fromDate: new UntypedFormControl(''),
    toDate: new UntypedFormControl(''),
    type: new UntypedFormControl([]),
    course: new UntypedFormControl([]),
    state: new UntypedFormControl([])
  });

  visible = true;
  selectable = true;
  removable = true;
  searching = false;

  filteredTypes: Observable<any[]>;
  selectedTypes: any[] = [];
  allTypes: any[] = [];
  @ViewChild('typesInput', {static: true}) typesInputRef: ElementRef<HTMLInputElement>;
  @ViewChild('autoTypes', {static: true}) matAutocompleteTypes: MatAutocomplete;

  filteredCourses: Observable<any[]>;
  selectedCourses: any[] = [];
  allCourses: any[] = [];
  @ViewChild('coursesInput', {static: true}) coursesInputRef: ElementRef<HTMLInputElement>;
  @ViewChild('autoCourses', {static: true}) matAutocompleteCourses: MatAutocomplete;

  filteredStates: Observable<any[]>;
  selectedStates: any[] = [];
  allStates: any[] = [];
  searchData: any;
  @ViewChild('statesInput', {static: true}) statesInputRef: ElementRef<HTMLInputElement>;
  @ViewChild('autoStates', {static: true}) matAutocompleteStates: MatAutocomplete;


  constructor(public dialModalRef: MatDialogRef<ReunionesBusquedaComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private reunionesService: ReunionesService) {
    if (data) {
      this.allTypes = data.types;
      this.allCourses = data.courses;
      this.allStates = data.states;
      this.searchData = data.searchData;
    }
  }

  ngOnInit() {
    this.dialModalRef.updatePosition({top: '64px'});

    this.filteredTypes = this.searchForm.get('type').valueChanges.pipe(
      startWith(null),
      map((type) => type ? this._filter(type, 'allTypes') : this.allTypes.slice()));

    this.filteredCourses = this.searchForm.get('course').valueChanges.pipe(
      startWith(null),
      map((course) => course ? this._filter(course, 'allCourses') : this.allCourses.slice()));

    this.filteredStates = this.searchForm.get('state').valueChanges.pipe(
      startWith(null),
      map((state) => state ? this._filter(state, 'allStates') : this.allStates.slice()));
    if (this.searchData) {
      this.searchForm.setValue({
        searchTerm: this.searchData.termino,
        fromDate: this.searchData.fechaInicio,
        toDate: this.searchData.fechaFin,
        type: null,
        course: null,
        state: null
      });
      this.selectedTypes = this.searchData.tipos;
      this.selectedCourses = this.searchData.cursos;
      this.selectedStates = this.searchData.estados;
    }
  }

  removed(element, collectionFrom, collectionTo, formField) {
    const elIndex = collectionFrom.findIndex(elementI => {
      return elementI.id === element.id;
    });
    // @ts-ignore
    collectionTo.push(element);
    if (elIndex > -1) {
      /*this.owners.splice(index, 1);*/
      collectionFrom.splice(elIndex, 1);
    }
    this.searchForm.get(formField).setValue(null);
  }

  selected(evt: MatAutocompleteSelectedEvent, collectionFrom, collectionTo, formField, input) {
    const ownerIndex = collectionFrom.findIndex(ownerI => ownerI['id'] === evt.option.value.id);
    collectionTo.push(evt.option.value);
    input.nativeElement.value = '';
    if (ownerIndex > -1) {
      collectionFrom.splice(ownerIndex, 1);
    }
    this.searchForm.get(formField).setValue(null);
  }

  onSubmit(): void {
    const formVals = this.searchForm.value,
      searchData = {
        termino: formVals.searchTerm,
        fechaInicio: moment(formVals.fromDate).format('YYYY-MM-DD'),
        fechaFin: moment(formVals.toDate).format('YYYY-MM-DD'),
        tipos: this.selectedTypes,
        cursos: this.selectedCourses,
        estados: this.selectedStates
      };
    this.searching = true;
    this.reunionesService.searchMeetings(searchData).subscribe(res => {
      const searchResult = this.reunionesService.extractData(res);
      this.dialModalRef.close({searchResult, searchData});
      // TODO: error handle
    });
  }

  private _filter(value: string, collection): string[] {
    const filterValue = value && typeof value === 'string' ? value.toLowerCase() : '';

    return this[collection].filter((colEl: any) => colEl.nombre.toLowerCase().indexOf(filterValue) > -1);
  }
}
